import { subcoInitials } from '../../lib/useSubcoCompanies';

export function SubcoLogo({ subco, size = 'h-6 w-6', text = 'text-[9px]' }) {
  if (subco?.logo_url) return <img src={subco.logo_url} alt={subco.name} className={`${size} rounded object-contain bg-white border border-slate-200 shrink-0`} />;
  return (
    <span className={`${size} ${text} rounded bg-gradient-to-br from-amber-400 to-orange-600 text-white font-black flex items-center justify-center shrink-0`}>
      {subcoInitials(subco?.name)}
    </span>
  );
}

export function SubcoBadge({ subco, name, testId }) {
  const label = subco?.name || name;
  if (!label) return null;
  return (
    <span className="inline-flex items-center gap-1 rounded-full border border-amber-200 bg-amber-50 text-amber-800 pl-0.5 pr-2 py-0.5 text-[10px] font-bold max-w-[160px]" data-testid={testId}>
      <SubcoLogo subco={subco || { name: label }} size="h-4 w-4" text="text-[7px]" />
      <span className="truncate">{label}</span>
    </span>
  );
}

export function TagChip({ tag, active, onClick, testId }) {
  const cls = active ? 'bg-slate-900 text-white border-slate-900' : 'bg-white dark:bg-slate-900 text-slate-600 border-slate-200 dark:border-slate-700 hover:border-slate-400';
  if (!onClick) return <span data-testid={testId} className={`rounded-full border px-2 py-0.5 text-[10px] font-semibold ${cls}`}>{tag}</span>;
  return (
    <button type="button" onClick={onClick} disabled={!onClick} data-testid={testId}
      className={`rounded-full border px-2 py-0.5 text-[10px] font-semibold transition-colors ${cls} ${onClick ? '' : 'cursor-default'}`}>
      {tag}
    </button>
  );
}
